import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import HeroSection from './screens/HeroSection';
import SecondScreen from './screens/SecondScreen';
import Services from './screens/Services';
import Projects from './screens/Projects';
import SketchToReal from './screens/SketchToReal';
import FAQ from './screens/FAQ';
import HeroShowcase from './pages/HeroShowcase';
import NewHome from './pages/NewHome';
import Privacy from './pages/Privacy';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

function HomePage() {
  useEffect(() => {
    ScrollTrigger.refresh();
  }, []);

  return (
    <div className="scroll-container">
      <HeroSection />
      <SecondScreen />
      <Services />
      <Projects />
      <SketchToReal />
      <FAQ />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<NewHome />} />
        <Route path="/old" element={<HomePage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/hero-showcase" element={<HeroShowcase />} />
      </Routes>
    </Router>
  );
}

export default App;
